/* Club Finder — live-store corrections & tuning. Loaded last (after rs-club-finder-1..4.js),
   so these reassign the globals defined in those files. Mirrors of pickMatches /
   pickMatchesLive in the canonical rs-club-finder.js, kept here because the deployed
   build is split across files (see SHOPIFY notes). */

/* (1) RS stores custom.flex as "<X> Flex" (e.g. "Regular Flex"), not "<X>".
   Fix the server-side flex metafield filter map so it actually matches. */
FLEX_VALUE = { regular:"Regular Flex", stiff:"Stiff Flex", senior:"Senior Flex", xstiff:"Extra Stiff Flex", ladies:"Ladies Flex", junior:"Junior Flex" };

/* (2) Gender separation across ALL club types: never show a ladies club to a men's
   customer, and never show a men's club to a women's customer. The gender field alone
   is unreliable (genderless categories like putters/wedges carry no "Ladies Flex", so
   mapNode tags them "mens"; the ladies marker is in the title/handle, e.g. "...Ladies
   Putter..."). So detect "ladies" by text as well as the gender field, and apply it to
   every category. (junior/other are left to the existing gender-field filter.) */
function rsIsLadies(c){
  var t = ((c.model || "") + " " + (c.h || "") + " " + (c.spec || "")).toLowerCase();
  return c.gender === "womens" || /ladies|lady|wom[ae]n/.test(t);
}
function rsKeepForGender(c, p){
  if (p.genderKey === "mens")   return !rsIsLadies(c);
  if (p.genderKey === "womens") return  rsIsLadies(c);
  return true;
}

/* (3) Re-pick with the gender rule applied to the POOL before ranking/slicing, so the
   customer still gets up to 6 relevant clubs (not 6-minus-the-excluded). */
pickMatches = function(p){
  var pool = (INVENTORY[p.cat] || []).slice().filter(function(c){ return rsKeepForGender(c, p); });
  var dexOk   = function(c){ return c.dex === p.hand; };
  var genOk   = function(c){ return p.genderless || c.gender === p.genderKey; };
  var inBand  = function(c){ return c.price >= p.budgetMin && c.price <= p.budgetMax; };
  var underMx = function(c){ return c.price <= p.budgetMax; };
  var note = "";
  var list = pool.filter(function(c){ return dexOk(c) && genOk(c) && inBand(c); });
  if (!list.length) { var t1 = pool.filter(function(c){ return dexOk(c) && genOk(c) && underMx(c); }); if (t1.length){ list = t1; note = "budget"; } }
  if (!list.length) { var t2 = pool.filter(function(c){ return dexOk(c) && genOk(c); }); if (t2.length){ list = t2; note = "budget"; } }
  if (!list.length) { var t3 = pool.filter(function(c){ return genOk(c) && inBand(c); }); if (t3.length){ list = t3; note = "hand"; } }
  if (!list.length) { list = pool.slice(); note = pool.length ? "stock" : "none"; }
  list.sort(function(a,b){ return rankClub(b,p) - rankClub(a,p); });
  if (note === "budget") list.sort(function(a,b){ return a.price - b.price; });
  return { items: list.slice(0, 6), note: note };
};

pickMatchesLive = function(p){
  if (!liveEnabled()) return Promise.resolve(pickMatches(p));
  var handle = CAT_COLLECTION[p.cat];
  var keep = function(c){ return c.dex === p.hand && rsKeepForGender(c, p); };
  return storefront({ handle: handle, n: STOREFRONT.poolSize, filters: buildFilters(p, true) })
    .then(function(nodes){
      var items = nodes.map(mapNode).filter(keep);
      if (items.length) return { items: rankPool(items, p), note: "" };
      return storefront({ handle: handle, n: STOREFRONT.poolSize, filters: buildFilters(p, false) })
        .then(function(n2){
          var i2 = n2.map(mapNode).filter(keep).sort(function(a,b){ return a.price - b.price; });
          return i2.length ? { items: i2.slice(0,6), note: "budget" } : { items: [], note: "none" };
        });
    })
    .catch(function(err){
      try { console.warn("Club Finder: live fetch failed, using snapshot —", err && err.message); } catch(e){}
      return pickMatches(p);
    });
};
